import React from "react";
import { formatCurrency } from "../../../helpers/estimateTotals";
import "./PayrollSummaryCards.css";

function buildSummaryCards(summary) {
  const cards = [
    {
      key: "entries",
      label: "Total Entries",
      value: summary.entryCount,
    },
    {
      key: "regularHours",
      label: "Regular Hours",
      value: Number(summary.regularHours || 0).toFixed(2),
    },
  ];

  if (Number(summary.overtimeHours || 0) > 0) {
    cards.push({
      key: "overtimeHours",
      label: "Overtime Hours",
      value: Number(summary.overtimeHours).toFixed(2),
    });
  }

  cards.push(
    {
      key: "breakHours",
      label: "Break Hours",
      value: Number(summary.breakHours || 0).toFixed(2),
    },
    {
      key: "grossPayroll",
      label: "Gross Payroll",
      value: formatCurrency(summary.grossPay || 0),
      emphasis: true,
    },
  );

  return cards;
}

export function PayrollSummaryCards({ summary, variant = "preview" }) {
  if (!summary) return null;

  const isPrint = variant === "print";
  const gridClass = isPrint
    ? "prp-payroll-summary-grid"
    : "er-payroll-summary-grid";
  const cardClass = isPrint
    ? "prp-payroll-summary-card"
    : "er-payroll-summary-card";
  const labelClass = isPrint
    ? "prp-payroll-summary-card__label"
    : "er-payroll-summary-card__label";
  const valueClass = isPrint
    ? "prp-payroll-summary-card__value"
    : "er-payroll-summary-card__value";

  return (
    <div className={gridClass}>
      {buildSummaryCards(summary).map((card) => (
        <div
          key={card.key}
          className={`${cardClass}${card.emphasis ? ` ${cardClass}--emphasis` : ""}`}
        >
          <div className={labelClass}>{card.label}</div>
          <div className={valueClass}>{card.value}</div>
        </div>
      ))}
    </div>
  );
}
